up.status.config.currentClasses.push('active')

up.viewport.config.fixedTopSelectors.push('.sticky-top')
up.viewport.config.fixedTopSelectors.push('.fixed-top')
up.viewport.config.duration = 300

up.form.config.groupSelectors.unshift('.form-group')
up.form.config.watchInputDelay = 150

up.link.config.preloadDelay = 100
up.network.config.concurrency = 1

up.fragment.config.mainTargets=['[up-main]', '[main]', ':layer']
up.layer.config.any.mainTargets.push('[up-main-target]')
up.layer.config.modal.mainTargets.push('[up-overlay-target]')

up.on('up:layer:open', () => { $(document.body).addClass('-modal-open') })
up.on('up:layer:close', () => { $(document.body).removeClass('-modal-open') })

up.network.config.progressBar = false

// Migration from 2.7.2 -> 3.0.0
up.fragment.config.runScripts = false

$(() => {
  if ($(document.body).attr('data-environment') === 'test') {
    // Disable animations globally so Capybara doesn't see duplicate elements during transitions
    up.motion.config.enabled = false
    // When revealing elements, don't animate the scrolling
    up.viewport.config.duration = 0
  }

  // show better errors
  // See https://makandracards.com/makandra/1433-detect-the-current-rails-environment-from-javascript-or-css
  if ($(document.body).attr('data-environment') === 'development') {

    // Returns true when your development server shows an error page.
    function isDevelopmentError(response) {
      return !response.ok && /Full backtrace|Better errors/.test(response.text)
    }

    // When the development server shows an error page, repeat the request as a full page load.
    up.on('up:request:loaded', function(event) {
      if (isDevelopmentError(event.response)) {
        event.request.loadPage()
      }
    })
  }
})

let defaultAutoCache = up.network.config.autoCache
up.network.config.autoCache = function (request) {
  return defaultAutoCache(request) && !request.url.includes('/edit')
}

up.history.config.updateMetaTags = true
